module.exports = __webpack_public_path__ + "media/images/salespartner/problem01-cd9e9918a6330d7c24575fb119f23910.svg";